<template>
  <div class="hide-in-print">
    <button type="button" @click="openPrintDialog()" class="btn d-flex align-items-center text-brand1">
      <span class="icon icon-drucken mr-2" aria-hidden="true"></span>
      {{ $t(i18nMessage) }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonPrint',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.print'
    },
  },
  methods: {
    openPrintDialog() {
      window.print()
    }
  }
});
</script>
